export class ApplyForm {
  creditLimit: number;
  exporter_id: any;
  credit_currency: string;
  financeScheme: string;
  remarks: string;
  minCreditLimit: number;
  minCreditPeriodExpected?: string;
}

export class CreditLimitDetails {
  agreement_required: boolean;
  amount_approved: number;
  amount_disbursed: number;
  amount_requested: number;
  approved_credit_limit: number;
  approved_currency: string;
  buyer_acceptance: string;
  buyer_id: number;
  buyer_mawani_ref_id: string;
  buyer_org_id: string;
  buyer_org_name: string;
  created_at: Date;
  credit_limit_finance_type: string;
  finance_product_type: string;
  credit_limit_status: string;
  deleted_at: Date;
  documents_required: string[];
  additional_document?: string[];
  fi_id: number;
  fi_org_name: string;
  id: number;
  discountRate: string | DiscountRateTenure[];
  organisation_acceptance: string;
  organisation_id: number;
  processing_fee: number | ProcessingFeeTenure[];
  processingFeeChargeType: string;
  annualProcessingFee: number;
  annualProcessingFeeType: string;
  overdueRate: string | OverdueRateTenure[];
  overdueRateType: any;
  requested_credit_limit: number;
  minimum_credit_limit_amount: number;
  minimum_credit_period?: string;
  requested_currency: string;
  seller_mawani_ref_id: string;
  seller_id: string;
  seller_org_id: string;
  seller_org_name: string;
  updated_at: Date;
  documents?: CreditLimitDocuments[];
  state_transactions?: any[];
  supported_currencies?: string[];
  agreementExpiryDate?: string;
  max_financing_tenure: number;
  max_sanctioned_amount_limit: number;
  seasonalDiscountRate: SeasonalDiscountRate;
  counter_party_acceptance: string;
  additionalFees: AdditionalFees[];
  counter_party_info: any[];
  product_deleted_at: string;
  discountRateType: any;
  importerDetail: any;
  exporterDetail: any;
  remarks: any[];
  company_eligibility_check?: boolean;
  finance_scheme?: string;
  tradingPartnersInfo?: any[];
  credit_risk_score?: string;
  floor_pricing?: number;
  lendingRemarks?: any[];
  userRolesInfo?: UserRoleInterface;
  is_lending_organisation?: boolean;
  financial_decisioning_documents?: any[];
  lendingDocuments?: CreditLimitDocuments[];
  overall_credit_limit?: number;
  active_user?: string;
  active_workflow?: string;
  sellerBankDetails?: bankAccountInterface;
  buyerBankDetails?: bankAccountInterface;
  dfsaCompanyRefId?: string;
  dfsaClientAgreementAccepted?: boolean;
  buyer_contacted_by_ops?: boolean;
  buyer_contacted_at?: Date;
  loanDocuments: any;
  bankDetails?: [bankAccountInterface];
  transaction_fees_percentage_type?: string;
  additional_terms?: string;
  max_finance_tenure_from_enabled?: boolean;
  days_from_bl_Date_for_disbursal?: number;
  max_finance_tenure_from?: MaxFinancingTenureFromEnum;
  dpwfsEligibilityInfo?: any[];
  tenureType?: string;
  fixedFloatingRateType?: string;
  marginDiscountRate?: string | DiscountRateTenure[];
  spread?: string;
  products?: any[];
  request_id?: string;
}
export interface UserRoleInterface {
  sectionAllowedInfo: SectionParamInterface;
  actionAllowedInfo: string[];
}

export interface SectionParamInterface {
  exporterImporterDetails?: string;
  creditLimitTerms?: string;
  finDecisioningDocs?: string;
  facilityAgreeements?: string;
  assignmentOfReceivables?: string;
  remarks?: string;
  internalComments?: string;
  approvedBorrowerFacilities?: string;
  inProcessBorrowerFacilities?: string;
  bankAccountDetails?: string;
  termSheetDocument?: string;
}

export interface DiscountRateTenure {
  days: number;
  tenure_discount_rate?: string;
  tenure_margin_rate?: string;
}

export interface OverdueRateTenure {
  days: number;
  tenure_overdue_rate: string;
}

export interface ProcessingFeeTenure {
  days: number;
  tenure_processing_fee: string;
}

export interface SeasonalDiscountRate {
  seasonal_discount_rate_type: any;
  start_date: string;
  end_date: string;
  seasonal_discount_rate_value: string;
}

export interface AdditionalFees {
  fee: string;
  fee_charge_type: string;
  fee_name: string;
}

export interface CreditLimitDocuments {
  created_at: string;
  deleted_at: Date;
  document_location: string;
  document_name: string;
  document_type: string;
  document_upload_id: string;
  id: number;
  owner_id: number;
  owner_type: string;
  updated_at: Date;
  uploaded_by: string;
  tenant_code?: string;
  enable_docusign?: boolean;
}

export interface Documents {
  key: string;
  value: string;
  text?: string;
  isValidate?: boolean;
  file?: any;
  disabled?: boolean;
}

export interface CountryData {
  country_name: string;
  country_code: string;
  selected?: boolean;
}

export class CreditLimitApply {
  organisationId: number;
  finInstId: number;
  creditLimitRequested: number;
  creditLimitFinanceType: string;
  buyerId: number;
  mawaniDocDetails?: number;
  mawaniOrgRefId?: string;
}

export class FiOnboardingForm {
  finance_inst_id: number;
  supported_finance_types: string | any[];
  is_agreement_required_for_transaction: boolean;
  documents_required: string | any[];
  subscription_start_date: Date | string
    ;
  annual_subscription_fees: number;
  finance_commission: number;
  transaction_fees_below_$10000: number;
  transaction_fees_$10000_to_$50000: number;
  transaction_fees_above_$50000: number;
  misc_fees_commission: number;
  data_archiving_fees: number;
  reporting_fees: number;
  client_incorporation_countries_ID_IF?: string | any[];
  counter_party_incorporation_countries_IF?: string | any[];
  client_incorporation_countries_RF?: string | any[];
}

export enum CreditLimitStateType {
  COMPLETED = 'Completed',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  REJECTED_BY_APPLICANT = 'Rejected By Applicant',
  REJECTED_BY_FI = 'Rejected By Financial Institution',
  REJECTED_BY_COUNTER_PARTY = 'Rejected By Counter Party',
  UNDER_ASSESSMENT = 'Under Assessment',
  EXPIRED = 'Expired',
  IMPORTER_ACCEPTANCE_PENDING = 'Importer Acceptance Pending',
  FI_ASSESSED = 'Financial Institution Assessed',
  LENDING_FI_ASSESSED = 'Loan Documents Issued',
  DOCUMENT_PENDING = 'Documents Pending',
  ELIGIBILITY_REJECTED_BY_FI = 'Eligibility Rejected',
  COMPANY_REJECTED_BY_FI = 'Company Rejected',
  ELIGIBILITY_REQUESTED = 'Eligibility Requested',
  DETAILS_REQUIRED = 'Details Required',
  DRAFT = 'DRAFT',
  SEND_REWORK = 'SEND_REWORK',
  SIGNATURE_PENDING = 'Signature Pending',
  FACILITY_DOCUMENTS_REVIEWED_BY_OPERATIONS = 'Facility Documents Reviewed By Operations',
  FACILITY_DOCUMENTS_REVIEWED_BY_OPERATIONS_AND_CREDIT = `Facility Documents Reviewed by Operations & Credit`,
  FACILITY_DOCUMENTS_REVIEWED_BY_OPERATIONS_CREDIT_AND_FM = `Facility Documents Reviewed by Operations, Credit & FM`,
  TERMS_ACCEPTED = 'Terms Accepted',
  REWORK_PENDING_BY_CREDIT_ANALYST = 'Rework Pending by Credit Analyst',
  DOCUMENT_REWORK_PENDING_BY_CREDIT_ANALYST = 'Document Rework Pending by Credit Analyst',
  UPDATE_REWORK_PENDING_BY_CREDIT_ANALYST = 'Update Rework Pending by Credit Analyst',
  TERM_SHEET_ACCEPTED = 'Term Sheet Accepted',
  TERM_SHEET_PUBLISHED = 'Term Sheet Published',
  SAVE_AS_DRAFT = 'Save As Draft',
  ELIGIBILITY_REQUESTED_DRAFT = 'Eligibility Request Draft',
  NEW_PRODUCT_ADDITION_REQUEST = 'Product Update Under Assessment',
  SECTOR_UPDATE_REQUEST = 'Sector Update Under Assessment',
  FACILITY_REQUESTED = 'Facility Requested',
  DOCUMENTS_REQUIRED = 'Documents Required',
  CONVERSION_REQUEST_PENDING_CLIENT_SUBMISSION = 'Conversion Request Pending Client Submission',
  CONVERSION_REQUEST_PENDING_CLIENT_RESUBMISSION = 'Conversion Request Pending Client Resubmission'
}

export type CurrencyType = {
  value: string;
  viewValue: string;
  selected: boolean;
}

export interface TradingPartnerInfo {
  tpCompanyName: string;
  tpCountry: any;
  tpCommodities: any[];
  tpOldRelationship?: any;
  tpOtherCommodities?: string;
  tpCommoditySource?: any[];
}

export interface bankAccountInterface {
  account_number: string;
  address: string;
  bank_branch_address: string;
  bank_branch_code: string;
  bank_id: number;
  bank_name: string;
  beneficiary_address_id: number;
  city: string;
  country: string;
  id: number;
  organisation_id: number;
  pin_code: string;
  province: string;
  swift_code: string;
}

export interface FIDetailInterface {
  finance_inst_data: any[],
  pricing_exception_data: any;
}

export enum MaxFinancingTenureFromEnum {
  DISBURSAL_DATE = 'Disbursal Date',
  INVOICE_DATE = 'Invoice Date',
  BL_DATE = 'BL Date',
}

export interface UploadDocumentInterface {
  flow_type: string;
  document_id: number;
  document_name: string;
  document_type: string;
  documentInputValue?: string;
}

export interface UploadedDocumentResponse {
  document_id: number;
  document_name: string;
  document_type: string;
}

export interface FacilityFeeInterface {
  enhancementDate?: string;
  agreementSignDate: string;
  agreementExpiryDate: string;
  tenure: number;
  approvedCurrency?: string;
  facilityFees: number;
  suggestedFacilityFee?: number;
  feeType: string; //['FACILITY_FEE', 'FACILITY_RENEWAL_FEE', 'FACILITY_ENHANCEMENT_FEE']
  paymentDetails?: PaymentDetailsInterface[];
  overlapTenure?: number;
  overlapRebate?: number;
  creditNoteApplied?: number;
  creditNoteCurrency?: string;
  netAnnualProcessingFee?: number;
  isDeferred?: boolean;
}

export interface PaymentDetailsInterface {
  bankPaymentReference: string;
  receiptDate: string;
  moneyRemitted: number;
  transactionUpdateDate: string;
  balanceFeeAmount: string;
  status: string;
  serialNo?: number;
}